<div class="settings-request-query-builder">
  <select class="settings-request-query-builder__status" [(ngModel)]="statusFilter">
    <option value="">Status</option>
    <option *ngFor="let status of statuses" [ngValue]="status">{{ status }}</option>
  </select>
  <input class="settings-request-query-builder__requester" type="text" [(ngModel)]="requesterFilter"
    placeholder="Requester Name">
  <input class="settings-request-query-builder__reviewer" type="text" [(ngModel)]="reviewerFilter"
    placeholder="Reviewer Name">
  <input class="settings-request-query-builder__setting" type="text" [(ngModel)]="settingFilter"
    placeholder="Setting Name">
  <button class="lx-btn lx-btn-negative settings-request-query-builder__search"
    (click)="onSearchClick()">Search</button>
  <button class="settings-request-query-builder__reset lx-btn lx-btn-text" (click)="reset()">
    <i class="lx-icon lx-reset"></i>
    <span> Reset</span>
  </button>
</div>